import { useLocale, useTranslate } from 'react-admin'

import type { EventMarker } from '../../data/source'
import { useEventName } from './useEventName'

/**
 * What an event's circle stands for: a stay's muelle ("32C"), a BOMBEO's
 * product with its tonnes ("SOSA CAUSTICA (6500)"), otherwise its type and
 * number ("MARPOL I #2", "BOMBEO #1 (6500)" without a product).
 */
export const useMarkerLabel = () => {
  const translate = useTranslate()
  const locale = useLocale()
  const eventName = useEventName()
  return (marker: EventMarker): string => {
    if (marker.type === 'PLACE') return marker.muelle ?? ''
    // A blank product names nothing.
    const product = marker.product?.trim()
    const name =
      product !== undefined && product !== ''
        ? product
        : translate('pages.scales.timeline.marker', { event: eventName({ ...marker, type: marker.type }), number: marker.number })
    return marker.quantityT === null ? name : `${name} (${marker.quantityT.toLocaleString(locale)})`
  }
}
